export default __webpack_public_path__ + "static/media/black_slight_search.070b03c2.svg";